import React, { useState } from "react"
import MetaTags from "react-meta-tags"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  Button,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap" 
// import images
import { Link } from "react-router-dom"
import classnames from "classnames"
import file_upload from "../../assets/images/file_upload.png"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

const AddBranch = () => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  // const [progressValue, setprogressValue] = useState(20)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab)
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      if (tab >= 1 && tab <= 5) {
        setoggleTabVertical(tab)
      }
    }
  }

  function toggleTabProgress(tab) {
    if (activeTabProgress !== tab) {
      if (tab >= 1 && tab <= 5) {
        setactiveTabProgress(tab)

        if (tab === 1) {
          setprogressValue(20)
        }
        if (tab === 2) {
          setprogressValue(40)
        }
        if (tab === 3) {
          setprogressValue(60)
        }
        if (tab === 4) {
          setprogressValue(80)
        }
        if (tab === 5) {
          setprogressValue(100)
        }
      }
    }
  }
  // ---------------------Upload Business Photos---------------------

  const [selectedImages, setSelectedImages] = useState([])

  const onSelectFile = event => {
    const selectedFiles = event.target.files
    const selectedFilesArray = Array.from(selectedFiles)

    const imagesArray = selectedFilesArray.map(file => {
      return URL.createObjectURL(file)
    })

    setSelectedImages(previousImages => previousImages.concat(imagesArray))

    // FOR BUG IN CHROME
    event.target.value = ""
  }

  function deleteHandler(image) {
    setSelectedImages(selectedImages.filter(e => e !== image))
    URL.revokeObjectURL(image)
  }

  // ---------------------Upload Business Photos End---------------------

  // ---------------------Food Certificate---------------------

  const [FoodSelectedImages, setFoodSelectedImages] = useState([])

  const FoodCertificateSelectFile = event => {
    const FoodSelectedImages = event.target.files
    const FoodSelectedImagesArray = Array.from(FoodSelectedImages)

    const imagesArray = FoodSelectedImagesArray.map(file => {
      return URL.createObjectURL(file)
    })

    setFoodSelectedImages(previousImages => previousImages.concat(imagesArray))

    // FOR BUG IN CHROME
    event.target.value = ""
  }

  function FoodCertificateDeleteHandler(image) {
    setFoodSelectedImages(FoodSelectedImages.filter(e => e !== image))
    URL.revokeObjectURL(image)
  }

  // ---------------------Food Certificate End---------------------

  // ---------------------Awards & Recognization---------------------

  const [AwardsSelectedImages, setAwardsSelectedImages] = useState([])

  const AwardsSelectFile = event => {
    const AwardsSelectedImages = event.target.files
    const AwardsSelectedImagesArray = Array.from(AwardsSelectedImages)

    const imagesArray = AwardsSelectedImagesArray.map(file => {
      return URL.createObjectURL(file)
    })

    setAwardsSelectedImages(previousImages =>
      previousImages.concat(imagesArray)
    )

    event.target.value = ""
  }

  function AwardsDeleteHandler(image) {
    setAwardsSelectedImages(AwardsSelectedImages.filter(e => e !== image))
    URL.revokeObjectURL(image)
  }

  // ---------------------Awards & Recognization End---------------------

  // ---------------------Upload Banner---------------------
  const [UploadBannerFile, setUploadBannerFile] = useState(null)
  const [UploadBannerPath, setUploadBanner] = useState("")
  const [UploadBannerPathX, setUploadBannerX] = useState("")
  const [UploadBusinessLogoKey1, setUploadBannerKey] = useState("")

  const OnchangeUploadBannerFile = e => {
    if (e.target.files[0]) {
      const file = e.target.files[0]
      var pattern = /image-*/

      if (!file.type.match(pattern)) {
        UploadBannerFile(null)
        setUploadBanner("")
        setUploadBannerKey(Math.random().toString(9).substring(2, 9))
        alert("Invalid format")
        //return false
      } else {
        setUploadBannerFile(e.target.files[0])
        setUploadBannerX("")
        setUploadBanner(URL.createObjectURL(file))
      }
    } else {
      setUploadBannerFile(null)
      setUploadBanner("")
    }
  }

  const removeUploadBanner = () => {
    setUploadBannerFile(null)
    setUploadBanner("")
    //document.getElementById("IconImage").value = null
    setUploadBannerKey(Math.random().toString(9).substring(2, 9))
  }

  // ------------------------Upload Banner End------------------------

  // ------------------------Upload Business Logo ------------------------

  const [UploadBusinessLogoFile, setUploadBusinessLogoFile] = useState(null)
  const [UploadBusinessLogoPath, setUploadBusinessLogoPath] = useState("")
  const [UploadBusinessLogoPathx, setUploadBusinessLogoPathx] = useState("")
  const [UploadBusinessLogoKey, setUploadBusinessLogoKey] = useState("")

  const UploadBusinessLogo = e => {
    if (e.target.files[0]) {
      const file = e.target.files[0]
      var pattern = /image-*/

      if (!file.type.match(pattern)) {
        UploadBusinessLogoFile(null)
        setUploadBusinessLogoPath("")
        setUploadBusinessLogoKey(Math.random().toString(9).substring(2, 9))
        alert("Invalid format")
        //return false
      } else {
        setUploadBusinessLogoFile(e.target.files[0])
        setUploadBusinessLogoPathx("")
        setUploadBusinessLogoPath(URL.createObjectURL(file))
      }
    } else {
      setUploadBusinessLogoFile(null)
      setUploadBusinessLogoPath("")
    }
  }

  const removeUploadBusinessLogo = () => {
    setUploadBusinessLogoFile(null)
    setUploadBusinessLogoPath("")
    //document.getElementById("IconImage").value = null
    setUploadBusinessLogoKey(Math.random().toString(9).substring(2, 9))
  }

  // ------------------------Upload Business Logo End ------------------------

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add Branch | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Add Branch" />
          <Row>
            <Col xl="12">
              {/* <Card>
                <CardBody> */}
                  <Row>
                    <Col sm="3">
                      <Card>
                        <CardBody>
                          <h4 className="card-title mb-4">Add Branch</h4>
                          <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                            <div className="steps clearfix">
                              <span
                                className={classnames({
                                  current: activeTab === 1,
                                })}
                              >
                                <NavLink
                                  className={classnames(
                                    { current: activeTab === 1 },
                                    "mb-3"
                                  )}
                                  onClick={() => {
                                    setactiveTab(1)
                                  }}
                                >
                                  Business Details
                                </NavLink>
                              </span>

                              <span
                                className={classnames({
                                  current: activeTab === 2,
                                })}
                              >
                                <NavLink
                                  className={classnames(
                                    { active: activeTab === 2 },
                                    "mb-3"
                                  )}
                                  onClick={() => {
                                    setactiveTab(2)
                                  }}
                                >
                                  Address Details
                                </NavLink>
                              </span>

                              <span
                                className={classnames({
                                  current: activeTab === 3,
                                })}
                              >
                                <NavLink
                                  className={classnames(
                                    { active: activeTab === 3 },
                                    "mb-3"
                                  )}
                                  onClick={() => {
                                    setactiveTab(3)
                                  }}
                                >
                                  Upload Images
                                </NavLink>
                              </span>

                              <span
                                className={classnames({
                                  current: activeTab === 4,
                                })}
                              >
                                <NavLink
                                  className={classnames(
                                    { active: activeTab === 4 },
                                    "mb-3"
                                  )}
                                  onClick={() => {
                                    setactiveTab(4)
                                  }}
                                >
                                  Business Documents
                                </NavLink>
                              </span>

                              <span
                                className={classnames({
                                  current: activeTab === 5,
                                })}
                              >
                                <NavLink
                                  className={classnames(
                                    { active: activeTab === 5 },
                                    "mb-3"
                                  )}
                                  onClick={() => {
                                    setactiveTab(5)
                                  }}
                                >
                                  Bank Details
                                </NavLink>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col sm="9">
                      <Card>
                        <CardBody>
                          {/* <h4 className="card-title mb-0">Business Profile</h4> */}
                          <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                            <div className="content clearfix">
                              <TabContent
                                activeTab={activeTab}
                                className="body"
                              >
                                <TabPane tabId={1}>
                                  <Form>
                                    <h4 className="card-title mb-4">
                                      Business Details
                                    </h4>
                                    <Row>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BusinessName">
                                              Business Name *
                                            </label>
                                            <Input
                                              id="BusinessName"
                                              name="BusinessName"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="Contact_Person_Name">
                                              Contact Person Name *
                                            </label>
                                            <Input
                                              id="ContactPersonName"
                                              name="ContactPersonName"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>

                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BusinessPhoneNo">
                                              Business Phone No *
                                            </label>
                                            <Input
                                              id="BusinessPhoneNo"
                                              name="BusinessPhoneNo"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="Vendor’sPhoneNo">
                                              Vendor’s Phone No *
                                            </label>
                                            <Input
                                              id="Vendor’sPhoneNo"
                                              name="Vendor’sPhoneNo"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BusinessEmail">
                                              Business Email *
                                            </label>
                                            <Input
                                              id="BusinessEmail"
                                              name="BusinessEmail"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BusinessCategory">
                                              Business Category *
                                            </label>
                                            <Input
                                              id="BusinessCategory"
                                              name="BusinessCategory"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="ShopOpenTime">
                                              Shop Open Time *
                                            </label>
                                            <Input
                                              id="ShopOpenTime"
                                              name="ShopOpenTime"
                                              type="time"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="ShopCloseTime">
                                              Shop Close Time *
                                            </label>
                                            <Input
                                              id="ShopCloseTime"
                                              name="ShopCloseTime"
                                              type="time"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="ReferredBy">
                                              Referred by
                                            </label>
                                            <Input
                                              id="ReferredBy"
                                              name="ReferredBy"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="ReferralCode">
                                              Referral Code
                                            </label>
                                            <Input
                                              id="ReferralCode"
                                              name="ReferralCode"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={8}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BusinessAddress">
                                              Business Address *
                                            </label>
                                            <Input
                                              id="BusinessAddress"
                                              name="BusinessAddress"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Form>
                                </TabPane>

                                <TabPane tabId={2}>
                                  <Form>
                                    <h4 className="card-title mb-4">
                                      Address Details
                                    </h4>
                                    <Row>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BusinessAddress">
                                              Business Address *
                                            </label>
                                            <Input
                                              id="BusinessAddress"
                                              name="BusinessAddress"
                                              type="textarea"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="Country">
                                              Country *
                                            </label>
                                            <Input
                                              type="select"
                                              id="Country"
                                              name="Country"
                                              className="form-select"
                                            >
                                              <option value="">
                                                ---&nbsp; Please Select Country
                                                &nbsp;---
                                              </option>
                                              <option value="IN">India</option>
                                              <option value="JM">
                                                Jarmani
                                              </option>
                                            </Input>
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="State">
                                              State *
                                            </label>
                                            <Input
                                              type="select"
                                              id="State"
                                              name="State"
                                              className="form-select"
                                            >
                                              <option value="">
                                                ---&nbsp; Please Select State
                                                &nbsp;---
                                              </option>
                                              <option value="GJ">
                                                Gujarat
                                              </option>
                                              <option value="MH">
                                                Maharashtra
                                              </option>
                                            </Input>
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="City">City *</label>
                                            <Input
                                              type="select"
                                              id="City"
                                              name="City"
                                              className="form-select"
                                            >
                                              <option value="">
                                                ---&nbsp; Please Select City
                                                &nbsp;---
                                              </option>
                                              <option value="ST">Surat</option>
                                              <option value="JM">
                                                Jamnagar
                                              </option>
                                            </Input>
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="Pincode">
                                              Pincode *
                                            </label>
                                            <Input
                                              id="Pincode"
                                              name="Pincode"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="Landmark">
                                              Landmark *
                                            </label>
                                            <Input
                                              id="Landmark"
                                              name="Landmark"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="StoreLocation">
                                              Store Location *
                                            </label>
                                            <Input
                                              id="StoreLocation"
                                              name="StoreLocation"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="Latitude">
                                              Latitude
                                            </label>
                                            <Input
                                              id="Latitude"
                                              name="Latitude"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="Longitude">
                                              Longitude
                                            </label>
                                            <Input
                                              id="Longitude"
                                              name="Longitude"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Form>
                                </TabPane>

                                <TabPane tabId={3}>
                                  <Form>
                                    <h4 className="card-title mb-4">
                                      Upload Images
                                    </h4>
                                    <Row>
                                      <Col md={6}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="UploadBanner">
                                              Upload Banner *
                                            </label>
                                            <br />
                                            <label className="file_block-1">
                                              <img
                                                src={file_upload}
                                                width="70"
                                                className="mt-4 mb-4"
                                              />
                                              {/* <img
                                        src="{{upload_file}}"
                                        alt=""
                                        style={{ width: "70px" }}
                                      /> */}
                                              <Input
                                                id="IconImage"
                                                name="UploadBusinessLogo"
                                                type="file"
                                                className="form-control file_none"
                                                accept="image/png, image/gif, image/jpeg"
                                                onChange={e =>
                                                  OnchangeUploadBannerFile(e)
                                                }
                                                key={
                                                  UploadBusinessLogoKey1 || ""
                                                }
                                              />
                                            </label>

                                            {UploadBannerPath ? (
                                              <>
                                                <span>
                                                  <img
                                                    //src={UploadBusinessLogoPath + "?" + new Date().toISOString()}
                                                    src={
                                                      UploadBannerPath +
                                                      UploadBannerPathX
                                                    }
                                                    alt="Icon"
                                                    style={{
                                                      width: "300px",
                                                      height: "180px",
                                                      borderRadius: "10px",
                                                      marginTop: "-220px",
                                                      backgroundColor:
                                                        "#d3eaf2",
                                                    }}
                                                  />
                                                </span>
                                                <span
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <a
                                                    className="link"
                                                    onClick={() =>
                                                      removeUploadBanner()
                                                    }
                                                  >
                                                    <i
                                                      className="fa fa-window-close"
                                                      style={{
                                                        fontSize: "20px",
                                                        transform:
                                                          "translateY(-190px)",
                                                        marginRight: "-19px",
                                                      }}
                                                    ></i>
                                                  </a>
                                                </span>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </Row>
                                      </Col>

                                      <Col md={6}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="UploadBusinessLogo">
                                              Upload Business Logo *
                                            </label>
                                            <br />
                                            <label className="file_block">
                                              <img
                                                src={file_upload}
                                                width="37"
                                                className="mt-4 mb-4"
                                              />
                                              {/* <img
                                        src="{{upload_file}}"
                                        alt=""
                                        style={{ width: "70px" }}
                                      /> */}
                                              <Input
                                                id="IconImage"
                                                name="UploadBusinessLogo"
                                                type="file"
                                                className="form-control file_none"
                                                accept="image/png, image/gif, image/jpeg"
                                                onChange={e =>
                                                  UploadBusinessLogo(e)
                                                }
                                                key={
                                                  UploadBusinessLogoKey || ""
                                                }
                                              />
                                            </label>

                                            <button
                                              className="btn btn-primary"
                                              style={{ marginLeft: "20px" }}
                                              type="submit"
                                            >
                                              Upload
                                            </button>
                                            {UploadBusinessLogoPath ? (
                                              <>
                                                <span>
                                                  <img
                                                    //src={UploadBusinessLogoPath + "?" + new Date().toISOString()}
                                                    src={
                                                      UploadBusinessLogoPath +
                                                      UploadBusinessLogoPathx
                                                    }
                                                    alt="Icon"
                                                    style={{
                                                      width: "60px",
                                                      height: "60px",
                                                      transform:
                                                        "translateX(-170px)",
                                                      backgroundColor:
                                                        "#d7edf5",
                                                      marginTop: "0px",
                                                    }}
                                                  />
                                                </span>
                                                <span
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  <a
                                                    className="link"
                                                    onClick={() =>
                                                      removeUploadBusinessLogo()
                                                    }
                                                  >
                                                    <i
                                                      className="fa fa-window-close"
                                                      style={{
                                                        fontSize: "20px",
                                                        transform:
                                                          "translateX(-155px) ",
                                                      }}
                                                    ></i>
                                                  </a>
                                                </span>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </Row>
                                      </Col>

                                      <Col md={12}>
                                        <Row className="mb-3">
                                          <label htmlFor="UploadBusinessPhotos">
                                            Upload Business Photos *
                                          </label>
                                          <div className="col-lg-12 row">
                                            <div className="col-md-2">
                                              <label className="file_block-2">
                                                <i
                                                  class="fa fa-plus"
                                                  style={{
                                                    fontSize: "38px",
                                                    color: "#000",
                                                    // padding: "23px 1px",
                                                  }}
                                                ></i>
                                                <Input
                                                  type="file"
                                                  name="images"
                                                  onChange={onSelectFile}
                                                  className="form-control file_none mb-3"
                                                  multiple
                                                  accept="image/png , image/jpeg, image/webp"
                                                />
                                              </label>
                                            </div>
                                            <div className="col-md-10">
                                              <div className="business_images">
                                                {selectedImages &&
                                                  selectedImages.map(
                                                    (image, index) => {
                                                      return (
                                                        <div
                                                          key={image}
                                                          className="business_image"
                                                        >
                                                          <img
                                                            src={image}
                                                            height="100"
                                                            width="100"
                                                            alt="upload"
                                                          />
                                                          <Link
                                                            onClick={() =>
                                                              deleteHandler(
                                                                image
                                                              )
                                                            }
                                                            style={{
                                                              position:
                                                                "absolute",
                                                            }}
                                                          >
                                                            <i
                                                              className="fa fa-window-close"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                              }}
                                                            ></i>
                                                          </Link>
                                                          {/* <p>{index + 1}</p> */}
                                                        </div>
                                                      )
                                                    }
                                                  )}

                                                <div className="w-100">
                                                  {selectedImages.length > 0 &&
                                                    (selectedImages.length >
                                                    20 ? (
                                                      <p className="error">
                                                        You can't upload more
                                                        than 10 images! <br />
                                                        <span>
                                                          please delete{" "}
                                                          <b>
                                                            {" "}
                                                            {selectedImages.length -
                                                              20}{" "}
                                                          </b>{" "}
                                                          of them{" "}
                                                        </span>
                                                      </p>
                                                    ) : (
                                                      <button
                                                        className="upload-btn btn btn-primary ml-3 mt-3"
                                                        onClick={() => {
                                                          console.log(
                                                            selectedImages
                                                          )
                                                        }}
                                                      >
                                                        UPLOAD{" "}
                                                        {selectedImages.length}{" "}
                                                        IMAGE
                                                        {selectedImages.length ===
                                                        1
                                                          ? ""
                                                          : "S"}
                                                      </button>
                                                    ))}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Form>
                                </TabPane>

                                <TabPane tabId={4}>
                                  <Form>
                                    <h4 className="card-title mb-4">
                                      Business Documents
                                    </h4>
                                    <Row>
                                      
                                      <Col md={12}>
                                        <Row className="mb-3">
                                          <label htmlFor="UploadFoodCertificate">
                                            Food Certificate *
                                          </label>
                                          <div className="col-lg-12 row">
                                            <div className="col-md-2">
                                              <label className="file_block-2">
                                                <i
                                                  class="fa fa-plus"
                                                  style={{
                                                    fontSize: "38px",
                                                    color: "#000",
                                                    // padding: "23px 1px",
                                                  }}
                                                ></i>
                                                <Input
                                                  type="file"
                                                  name="FoodCertificate"
                                                  onChange={
                                                    FoodCertificateSelectFile
                                                  }
                                                  className="form-control file_none mb-3"
                                                  multiple
                                                  accept="image/png , image/jpeg, image/webp"
                                                />
                                              </label>
                                            </div>
                                            <div className="col-md-10">
                                              <div className="business_images">
                                                {FoodSelectedImages &&
                                                  FoodSelectedImages.map(
                                                    (image, index) => {
                                                      return (
                                                        <div
                                                          key={image}
                                                          className="business_image"
                                                        >
                                                          <img
                                                            src={image}
                                                            height="100"
                                                            width="100"
                                                            alt="upload"
                                                          />
                                                          <Link
                                                            onClick={() =>
                                                              FoodCertificateDeleteHandler(
                                                                image
                                                              )
                                                            }
                                                            style={{
                                                              position:
                                                                "absolute",
                                                            }}
                                                          >
                                                            <i
                                                              className="fa fa-window-close"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                              }}
                                                            ></i>
                                                          </Link>
                                                          {/* <p>{index + 1}</p> */}
                                                        </div>
                                                      )
                                                    }
                                                  )}

                                                <div className="w-100">
                                                  {FoodSelectedImages.length >
                                                    0 &&
                                                    (FoodSelectedImages.length >
                                                    20 ? (
                                                      <p className="error">
                                                        You can't upload more
                                                        than 10 images! <br />
                                                        <span>
                                                          please delete{" "}
                                                          <b>
                                                            {" "}
                                                            {FoodSelectedImages.length -
                                                              20}{" "}
                                                          </b>{" "}
                                                          of them{" "}
                                                        </span>
                                                      </p>
                                                    ) : (
                                                      <button
                                                        className="upload-btn btn btn-primary ml-3 mt-3"
                                                        onClick={() => {
                                                          console.log(
                                                            FoodSelectedImages
                                                          )
                                                        }}
                                                      >
                                                        UPLOAD{" "}
                                                        {
                                                          FoodSelectedImages.length
                                                        }{" "}
                                                        IMAGE
                                                        {FoodSelectedImages.length ===
                                                        1
                                                          ? ""
                                                          : "S"}
                                                      </button>
                                                    ))}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Row>
                                      </Col>

                                      <Col md={12}>
                                        <Row className="mb-3">
                                          <label htmlFor="UploadAwardsRecognization">
                                            Awards & Recognization *
                                          </label>
                                          <div className="col-lg-12 row">
                                            <div className="col-md-2">
                                              <label className="file_block-2">
                                                <i
                                                  class="fa fa-plus"
                                                  style={{
                                                    fontSize: "38px",
                                                    color: "#000",
                                                    // padding: "23px 1px",
                                                  }}
                                                ></i>
                                                <Input
                                                  type="file"
                                                  name="AwardsRecognization"
                                                  onChange={AwardsSelectFile}
                                                  className="form-control file_none mb-3"
                                                  multiple
                                                  accept="image/png , image/jpeg, image/webp"
                                                />
                                              </label>
                                            </div>
                                            <div className="col-md-10">
                                              <div className="business_images">
                                                {AwardsSelectedImages &&
                                                  AwardsSelectedImages.map(
                                                    (image, index) => {
                                                      return (
                                                        <div
                                                          key={image}
                                                          className="business_image"
                                                        >
                                                          <img
                                                            src={image}
                                                            height="100"
                                                            width="100"
                                                            alt="upload"
                                                          />
                                                          <Link
                                                            onClick={() =>
                                                              AwardsDeleteHandler(
                                                                image
                                                              )
                                                            }
                                                            style={{
                                                              position:
                                                                "absolute",
                                                            }}
                                                          >
                                                            <i
                                                              className="fa fa-window-close"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                              }}
                                                            ></i>
                                                          </Link>
                                                          {/* <p>{index + 1}</p> */}
                                                        </div>
                                                      )
                                                    }
                                                  )}

                                                <div className="w-100">
                                                  {AwardsSelectedImages.length >
                                                    0 &&
                                                    (AwardsSelectedImages.length >
                                                    20 ? (
                                                      <p className="error">
                                                        You can't upload more
                                                        than 10 images! <br />
                                                        <span>
                                                          please delete{" "}
                                                          <b>
                                                            {" "}
                                                            {AwardsSelectedImages.length -
                                                              20}{" "}
                                                          </b>{" "}
                                                          of them{" "}
                                                        </span>
                                                      </p>
                                                    ) : (
                                                      <button
                                                        className="upload-btn btn btn-primary ml-3 mt-3"
                                                        onClick={() => {
                                                          console.log(
                                                            AwardsSelectedImages
                                                          )
                                                        }}
                                                      >
                                                        UPLOAD{" "}
                                                        {
                                                          AwardsSelectedImages.length
                                                        }{" "}
                                                        IMAGE
                                                        {AwardsSelectedImages.length ===
                                                        1
                                                          ? ""
                                                          : "S"}
                                                      </button>
                                                    ))}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Form>
                                  {/* <div className="row justify-content-center">
                            <Col lg="6">
                              <div className="text-center">
                                <div className="mb-4">
                                  <i className="mdi mdi-check-circle-outline text-success display-4" />
                                </div>
                                <div>
                                  <h5>Confirm Detail</h5>
                                  <p className="text-muted">
                                    If several languages coalesce, the grammar
                                    of the resulting
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </div> */}
                                </TabPane>

                                <TabPane tabId={5}>
                                  <Form>
                                    <h4 className="card-title mb-4">
                                      Bank Details
                                    </h4>
                                    <Row>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BankName">
                                              Bank Name *
                                            </label>
                                            <Input
                                              id="BankName"
                                              name="BankName"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="AccountHolderName">
                                              Account Holder Name *
                                            </label>
                                            <Input
                                              id="AccountHolderName"
                                              name="AccountHolderName"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="AccountNo">
                                              Account No *
                                            </label>
                                            <Input
                                              id="AccountNo"
                                              name="AccountNo"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="IBAN-IFSC">
                                              IBAN / IFSC No *
                                            </label>
                                            <Input
                                              id="IBAN-IFSC"
                                              name="IBAN-IFSC"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="BranchName">
                                              Branch Name *
                                            </label>
                                            <Input
                                              id="BranchName"
                                              name="BranchName"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                      <Col md={4}>
                                        <Row className="mb-3">
                                          <div className="col-lg-12">
                                            <label htmlFor="APIKey">
                                              API Key *
                                            </label>
                                            <Input
                                              id="APIKey"
                                              name="APIKey"
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Form>
                                </TabPane>
                              </TabContent>
                            </div>

                            <div className="actions clearfix">
                              <ul>
                                <li
                                  className={
                                    activeTab === 1
                                      ? "previous disabled"
                                      : "previous"
                                  }
                                >
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    onClick={() => {
                                      toggleTab(activeTab - 1)
                                    }}
                                  >
                                    Previous
                                  </Link>
                                </li>
                                <li
                                  className={
                                    activeTab === 5 ? "next disabled" : "next"
                                  }
                                >
                                  <Link
                                    to="#"
                                    className="btn btn-primary"
                                    onClick={() => {
                                      toggleTab(activeTab + 1)
                                    }}
                                  >
                                    Next
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Button color="primary" type="submit">
                    Submit form
                  </Button>
                {/* </CardBody>
              </Card> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddBranch
